import React from "react";
import { Image, Modal, Space, Typography } from "antd";
import StatusDropdown from "../../../components/common/statusDropdown";

const TicketDetailsModal = ({
  onCancel,
  issueTitle,
  issueDescription,
  attachment,
  user,
  status,
  onStatusChange,
}) => {
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        className="top-[23%]"
        onCancel={onCancel}
        width="479px"
      >
        <Typography.Title level={4}>Ticket Details</Typography.Title>
        
        <div className="mb-4">
          <StatusDropdown
            value={status}
            onChange={onStatusChange}
            variant="modal"
          />
        </div>

        <div>
          <Typography.Title level={5}>Contact Info</Typography.Title>
          <Typography.Paragraph>{user?.firstName} {user?.lastName}</Typography.Paragraph>
          <Typography.Paragraph>{user?.phoneNumber}</Typography.Paragraph>
          <Typography.Paragraph>{user?.email}</Typography.Paragraph>
        </div>
        <div>
          <Typography.Title level={5}>Reason</Typography.Title>
          <Typography.Paragraph>{issueTitle}</Typography.Paragraph>
        </div>
        <div>
          <Typography.Title level={5}>Description</Typography.Title>
          <Typography.Paragraph level={5}>
            {issueDescription}
          </Typography.Paragraph>
        </div>
        <div>
          <Typography.Title level={5}>Attachment(s)</Typography.Title>
          {attachment ? (
            <Space className="mt-1">
              <Image
                src={attachment}
                width={100}
                height={100}
                preview={true}
                alt="attachment"
                className="rounded object-cover"
              />
            </Space>
          ) : (
            <>N/A</>
          )}
        </div>
      </Modal>
    </div>
  );
};
export default TicketDetailsModal;
